var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// node_modules/core-js/modules/_html.js